export default [
  {
    key: 'logo',
    initKey: 'logoUrl',
    label: 'field.logo',
    rules: '',
    type: 'single-image',
    pw: 200,
    ph: 200,
    fullWidth: false,
  },
  {
    cols: 12,
    hide: true,
  },
  {
    key: 'qrCodeKhr',
    initKey: 'qrCodeKhrUrl',
    label: 'field.qrCode',
    subLabel: '(៛)',
    rules: '',
    type: 'single-image',
    pw: 200,
    ph: 200,
    fullWidth: false,
  },
  {
    key: 'qrCodeUsd',
    initKey: 'qrCodeUsdUrl',
    label: 'field.qrCode',
    subLabel: '($)',
    rules: '',
    type: 'single-image',
    pw: 200,
    ph: 200,
    fullWidth: false,
  },
  {
    cols: 12,
    hide: true,
  },
  {
    key: 'agentId',
    label: 'field.agent',
    rules: 'required',
    type: 'nAsynSingleSelection',
    repository: 'agent',
    selectionKey: 'id',
    selectionLabel: 'username',
  },
  {
    key: 'bankName',
    label: 'field.name',
    rules: 'required',
    type: 'text',
  },
  {
    cols: 12,
    hide: true,
  },
  {
    key: 'isEnable',
    label: 'status.active',
    rules: '',
    type: 'checkbox',
    cols: 'auto',
  },
]
